import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { A11y, Autoplay, Navigation, Scrollbar } from "swiper/modules";
import { useMobileDetect } from "@/hooks";
import {
  Banner,
  BannerStatus,
  useGetAllBanners,
} from "@/services/banner.service.ts";
import { useEffect, useState } from "react";
import { useBannerStore } from "@/stores/banner/banner.store.ts";

type Partner = {
  id: number;
  imageUrl?: string;
  mobileImageUrl?: string;
  url: string;
};

interface HomeCarouselProps {
  inPreview: boolean;
}

export default function HomeCarousel({ inPreview }: HomeCarouselProps) {
  const isMobile = useMobileDetect();

  // Fetch banners
  const pagination = { page: 1, limit: 9 };
  const { data: resp } = useGetAllBanners(pagination);

  // From store
  const { banners: previewBanners } = useBannerStore();

  const [partners, setPartners] = useState<Partner[]>([]);

  useEffect(() => {
    let bannersToUse: Banner[] = [];
    if (inPreview && previewBanners?.length > 0) {
      bannersToUse = previewBanners;
    } else if (resp?.data?.data) {
      bannersToUse = resp.data.data;
    }

    if (bannersToUse.length > 0) {
      setPartners(
        bannersToUse
          .filter((banner: Banner) => banner.status === BannerStatus.SHOWING)
          .map((banner: any) => ({
            id: banner.id,
            imageUrl: banner.desktopUrl || "",
            mobileImageUrl: banner.mobileUrl || "",
            url: "/bonuses",
          })),
      );
    }
  }, [inPreview, resp?.data?.data, previewBanners]);

  return (
    <div className="w-full min-w-fill-available">
      <Swiper
        slidesPerView={1}
        modules={[Autoplay, Navigation, Scrollbar, A11y]}
        freeMode={true}
        loop={true}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        speed={1300}
        spaceBetween={0}
        className="mySwiper flex min-h-[220px] flex-col items-end rounded-2xl lg:min-h-[352.97px]"
      >
        {partners.map((item) => (
          <SwiperSlide key={item.id} className={"!flex justify-center"}>
            <a href={item.url}>
              <img
                className="hover:cursor-pointer lg:max-h-[353px]"
                src={isMobile ? item.mobileImageUrl : item.imageUrl}
                alt="banner"
              />
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
